import styled from "styled-components";

export const ConfigureNodeContainer = styled.div`
  background-color: #0a85c7;
  padding: 0.5rem 1rem;
  width: fit-content;
  height: fit-content;
  border-radius: 25px;
  display: flex;
  align-items: center;
  column-gap: 0.5rem;
`;

export const ConfigureContent = styled.div`
  font-size: 14px;
  font-weight: 700;
  line-height: 1rem;
  color: white;
`;
export const ContentContainer = styled.div<{ isConfigurable?: boolean }>`
  grid-column: 1/-1;
  margin-top: 10px;
  align-items: center;
  font-size: 12px;
  display: flex;
  padding: 3px;
  column-gap: 0.25rem;
  color: ${(props) => (props.isConfigurable ? "#8C670B" : "#37B036")};
  background-color: ${(props) => (props.isConfigurable ? "#FFEAB6" : "unset")};
`;
export const NodeContainer = styled.div<{ isConfigurable?: boolean }>`
  opacity: ${(props) => (props.isConfigurable ? "1" : "0.7")};
  display: grid;
  grid-template-columns: max-content 1fr;
  height: 100%;
  width: 275px;
  border: ${(props) =>
    props.isConfigurable ? "2px dashed #0A85C7" : "1px solid #90a8b5"};
  border-radius: 8px;
  padding: 1rem;
  grid-column-gap: 10px;
  position: relative;
  background-color: #f6fdff;
`;
